import { apiFetch } from '@/shared/api/client'

export type ApiDeliveryLine = {
  id: string
  product_name: string
  production_date: string
  qty: number
}

export type ApiDelivery = {
  id: string
  code: string
  store_name: string
  delman_name: string
  status: 'draft' | 'prepared' | 'in_transit' | 'received'
  updated_at: string
  dispatched_at?: string
  lines: ApiDeliveryLine[]
}

export type ApiTodayDeliveries = {
  deliveries: ApiDelivery[]
}

export async function fetchTodayDeliveries(deviceId: string): Promise<ApiTodayDeliveries> {
  const encoded = encodeURIComponent(deviceId)
  return apiFetch<ApiTodayDeliveries>(`/kitchen/deliveries/today?device_id=${encoded}`)
}
